export default __webpack_public_path__ + "static/media/authpublickey.key.9791c692.pub";